import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {cssTheme} from '@yandex-delivery/blocks/theme'

export const box = css`
  background-color: ${cssTheme.default.day.backgroundInvert};
  z-index: 11;
`

export const header = css`
  inline-size: 100%;
  background: ${cssTheme.default.day.everWhite};
  border-radius: ${spacing(0, 0, 4, 4)};
`

export const mainLine = css`
  padding: ${spacing(2)};
`

export const link = css`
  margin-block: ${spacing(1)};
  display: inline-block;
`
